import React from 'react';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { DatabrainBubbleContent } from '@/pages/home/pages/home/components/DataSource';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import { valueFormat, growthFormat } from '@/pages/intelligence/utils/commonUtils';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import { useIntl, getLocale } from 'umi';
import { toActiveUsersTag, toActiveUsersTagToCN } from '@/pages/intelligence/utils/common';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import {
  DataSourceBubbleInfo,
  DATASOURCE_NAME,
} from '@/pages/intelligence/components/DataSourceComponents';
import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';

import type { IDataCompareData, IDataCompareHelper } from '@intelligence/v3/components/DataCompareBubble';

interface DAUColumnType {
  key: string;
  title: string;
  title_cn?: string;
  title_en?: string;
  dataSource: string; // DataSourceMetricType | 'ogdb'; //'appannie' | 'sensortower' | 'ogdb';
  currentSortKey: string;
  currentSortValue: string; // '' | 'desc' | 'asc';
  onSortChage: (e: SortByItemType) => void;
  sortMetric: string;
  textContent: React.ReactNode;
  tipText?: React.ReactNode;
  width?: number;
  width_cn?: number;
  isNoDropdown?: boolean;
  isRank?: boolean;
  renderType?: number;
  getMetricValueOfCvm: (
    cvm: any,
    metricKey: string,
    dataSource: string
  ) => {
    value: string | number;
    growthDataObj: {
      value: string | number;
      type: string;
    };
    dataCompareData?: IDataCompareData & IDataCompareHelper;
  };
  metricKey?: string;
  entityType?: string;
}

const getTitleContent = (cfg: {
  showTextBubble?: boolean;
  dataSource: string;
  metric: string;
  textContent?: any;
  tipText?: any;
}) => {
  const { showTextBubble, dataSource, metric, textContent, tipText } = cfg || {};

  const { formatMessage } = useIntl();

  const element = showTextBubble ? (
    <>
      {textContent ? textContent : null}
      {textContent && tipText && <br />}
      {tipText ? tipText : null}
    </>
  ) : null;

  const showDataSourceRangeInfo =
    ['appannie', 'sensortower'].includes(dataSource) &&
    ['dau', 'wau', 'mau', 'revenue', 'download', 'arpu'].includes(metric);

  return !showDataSourceRangeInfo ? (
    element
  ) : (
    <>
      {element}
      {
        <>
          <br />
          {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
        </>
      }
    </>
  );
};

export const ActiveUserMetricColumn = (params: DAUColumnType) => {
  const {
    key,
    title,
    sortMetric,
    dataSource,
    currentSortKey,
    currentSortValue,
    textContent,
    tipText,
    onSortChage,
    getMetricValueOfCvm = () => console.log,
    isNoDropdown = false,
    width = 180,
    width_cn,
    title_cn,
    title_en,
    renderType,
    metricKey,
    entityType = '',
  } = params;

  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const onlyValueSort = renderType === RenderType.GROWTH_ONLY;
  const localeWidth = locale === LANGUAGE_CN ? width_cn || width : width;

  return {
    key,
    width: localeWidth,
    align: 'center',
    header: () => {
      /** 当不是环比排序时，表格标题文本有提示文本 */
      const showTextBubble = currentSortKey !== `${key}_1`;
      return (
        <CloumsCenter width={localeWidth} align={'right'}>
          <SortBy
            title={title}
            defaultKey={currentSortKey}
            defaultValue={currentSortValue}
            svgIcon={getDataSourceIcon(dataSource)}
            isNoDropdown={isNoDropdown}
            list={
              onlyValueSort
                ? [
                    {
                      key: `${key}_0`,
                      sortMetric,
                      orderSource: dataSource,
                      text: title,
                      title,
                      title_cn,
                      title_en,
                      ratioType: 0,
                    },
                  ]
                : [
                    {
                      key: `${key}_0`,
                      sortMetric,
                      orderSource: dataSource,
                      text: title,
                      title,
                      title_cn,
                      title_en,
                      ratioType: 0,
                    },
                    {
                      key: `${key}_1`,
                      sortMetric,
                      orderSource: dataSource,
                      text: `${title}:${formatMessage({
                        id: 'dbi_change',
                      })}(%)`,
                      title: title === 'Revenue($)' ? 'Revenue($)%' : `${title}(%)`,
                      title_cn,
                      title_en,
                      ratioType: 1,
                    },
                  ]
            }
            onChange={onSortChage}
            svgTip={
              dataSource === 'ogdb' ? (
                <DatabrainBubbleContent
                  sourceNameLocalId={title}
                  metric={'databarin'}
                  metricKey={metricKey || sortMetric}
                  entityType={entityType}
                />
              ) : (
                <DataSourceBubbleInfo
                  dataOfDom={title}
                  metricKey={metricKey || sortMetric}
                  entityType={entityType}
                  comesFormDom={
                    <>
                      <img src={getDataSourceIcon(dataSource)} />
                      {DATASOURCE_NAME[dataSource]}
                    </>
                  }
                  dataSource={dataSource}
                />
              )
            }
            // content={
            //   showTextBubble ? (
            //     <>
            //       {textContent ? textContent : null}
            //       {textContent && tipText && <br />}
            //       {tipText ? tipText : null}
            //     </>
            //   ) : null
            // }
            content={getTitleContent({
              showTextBubble,
              dataSource,
              metric: sortMetric,
              textContent,
              tipText,
            })}
            // tipText={tipText}
            isSourceMetricBub={true}
          />
        </CloumsCenter>
      );
    },
    render: (cvm: any) => {
      const { value, growthDataObj, dataCompareData } = getMetricValueOfCvm(cvm, sortMetric, dataSource);
      if (renderType === RenderType.GROWTH_ONLY) {
        return (
          <CloumsCenter width={localeWidth} align={'right'}>
            <>{value}</>
          </CloumsCenter>
        );
      }
      return (
        <CloumsCenter width={localeWidth} align={'center'}>
          <TableShowData
            maxNumber={'99999+%'}
            value={value}
            type={growthDataObj?.type}
            growth={growthDataObj?.value}
            dataCompareData={dataCompareData}
          />
        </CloumsCenter>
      );
    },
  };
};

export const RankColumn = (params: DAUColumnType) => {
  const { key, title, currentSortKey, currentSortValue, width = 100, isRank = false } = params;

  return {
    key,
    width,
    align: 'center',
    header: () => (
      <CloumsCenter width={width} align={'right'}>
        <SortBy
          title={title}
          defaultKey={currentSortKey}
          defaultValue={currentSortValue}
          isNoDropdown={true}
        />
      </CloumsCenter>
    ),
    render: (cvm: any) => {
      const metrics = cvm?.metrics || [];
      const metric = metrics.find((item: any) => item?.metric === key);
      const value = valueFormat(metric?.value);
      const growthDataObj = growthFormat({
        value: isRank ? -metric?.growth_ratio : metric?.growth_ratio,
        valueType: 'rankValue',
        hasPoint: 'none',
        fixedNum: 0,
        maxNumber: 999,
        zeroValue: '=',
      });
      return (
        <CloumsCenter width={width} align={'center'}>
          <TableShowData
            maxNumber={'999+'}
            value={value}
            type={growthDataObj?.type}
            growth={growthDataObj?.value}
          />
        </CloumsCenter>
      );
    },
  };
};

const TopTip = (props: any) => {
  const { title } = props;
  const { formatMessage } = useIntl(); // 中英切换方法
  let tip: React.ReactNode = '';
  switch (title) {
    case 'avg':
      tip = formatMessage({ id: 'dbi_info_avg_selected' });
      break;
    case 'sum':
      tip = formatMessage({ id: 'dbi_info_sum_selected' });
      break;
    case 'revenue':
      // tip = (
      //   <>
      //     <p>{formatMessage({ id: `dbi_info_sum_selected` })}</p>
      //     <p>{formatMessage({ id: `dbi_info_revenue_removed` })}</p>
      //   </>
      // );
      tip = (
        <>
          {formatMessage({ id: `dbi_info_sum_selected` })}
          <br />
          {formatMessage({ id: `dbi_info_revenue_removed_new` })}
        </>
      );
      break;
    case 'arpu':
      tip = formatMessage({ id: 'dbi_info_revenue_arpu' });
      break;
    default:
      tip = '';
      break;
  }
  return <>{tip}</>;
};

const EditionCountryTip = (props: any) => {
  const { title, tab, type, dataSource, dateType } = props;
  let tip: React.ReactNode = '';
  const local = getLocale();
  const { formatMessage } = useIntl(); // 中英切换方法
  if (tab === 'countries') {
    if (title === 'Activeusers') {
      tip = formatMessage(
        { id: 'dbi_country_activeuser_info' },
        { dateType },
        // { dateType: local === LANGUAGE_CN ? '中文TODO' : dateType },
      );
    }
    if (title === 'Revenue' && type === 'sum') {
      tip = formatMessage({ id: 'dbi_country_revenue_sum_info' });
    }
    if (title === 'Revenue' && type === 'avg') {
      tip = formatMessage({ id: 'dbi_country_revenue_avg_info' });
    }
    if (title === 'Downloads' && type === 'sum') {
      tip = formatMessage({ id: 'dbi_country_dowload_sum_info' });
    }
    if (title === 'Downloads' && type === 'avg') {
      tip = formatMessage({ id: 'dbi_country_dowload_avg_info' });
    }
  } else if (tab === 'editions') {
    if (title === 'Activeusers') {
      tip = formatMessage({ id: 'dbi_edition_activeuser_info' }, { dateType });
    }
    if (title === 'Revenue' && type === 'sum') {
      tip = formatMessage({ id: 'dbi_edition_revenue_sum_info' });
    }
    if (title === 'Revenue' && type === 'avg') {
      tip = formatMessage({ id: 'dbi_edition_revenue_avg_info' });
    }
    if (title === 'Downloads' && type === 'sum') {
      tip = formatMessage({ id: 'dbi_edition_dowload_sum_info' });
    }
    if (title === 'Downloads' && type === 'avg') {
      tip = formatMessage({ id: 'dbi_edition_dowload_avg_info' });
    }
  }

  return <>{tip}</>;
};
export const dauTitle = (dateType: string) => ({
  title: toActiveUsersTag[dateType] || 'DAU',
  title_cn: toActiveUsersTagToCN[dateType] || '日活用户',
  key: 'dau',
  textContent: <TopTip title="avg" />,
  metricKey: toActiveUsersTag[dateType] || 'DAU',
});
export const avgDAUTitle = (params: any) => {
  const { formatMessage } = useIntl();
  return {
    title: `Avg ${toActiveUsersTag[params?.dateType]}` || 'Avg DAU',
    title_cn: `平均${toActiveUsersTagToCN[params?.dateType]}` || '平均日活用户',
    key: 'avg_dau',
    textContent: <TopTip title="avg" />,
    tipText: (
      <>
        <EditionCountryTip type={'avg'} {...(params || {})} />
        <br />
        {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
      </>
    ),

    width: 220,
  };
};
// export const sumDAUTitle = (dateType: string) => {
//   return {
//     title: toActiveUsersTag[dateType] || 'Sum DAU',
//     key: 'sum_dau',
//     textContent: <TopTip title="sum" />,
//     tipText: '?',
//     width: 230,
//   };
// };
export const revenueTitle = {
  title: 'Revenue($)',
  title_cn: '收入(美元)',
  key: 'revenue',
  textContent: <TopTip title="revenue" />,
  width: 180,
};
export const avgRevenueTitle = (params: any) => {
  const { formatMessage } = useIntl();
  return {
    title: 'Avg Revenue',
    title_cn: '平均收入',
    key: 'avg_revenue',
    textContent: <TopTip title="avg" />,
    tipText: (
      <>
        <EditionCountryTip type={'avg'} {...(params || {})} />
        <br />
        {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
      </>
    ),
    width: 230,
    width_cn: 150,
  };
};
export const sumRevenueTitle = (params: any) => {
  const { formatMessage } = useIntl();
  return {
    title: 'Sum Revenue',
    title_cn: '总收入',
    key: 'sum_revenue',
    textContent: <TopTip title="sum" />,
    tipText: (
      <>
        <EditionCountryTip type={'sum'} {...(params || {})} />
        <br />
        {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
      </>
    ),
    width: 230,
    width_cn: 150,
  };
};
export const downloadTitle = {
  title: 'Downloads',
  title_cn: '下载',
  key: 'download',
  textContent: <TopTip title="sum" />,
};
export const avgDownloadTitle = (params: any) => {
  const { formatMessage } = useIntl();
  return {
    title: 'Avg Downloads',
    title_cn: '平均下载',
    key: 'avg_download',
    textContent: <TopTip title="avg" />,
    tipText: (
      <>
        <EditionCountryTip type={'avg'} {...(params || {})} />
        <br />
        {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
      </>
    ),
    width: 200,
  };
};
export const sumDownloadTitle = (params: any) => {
  const { formatMessage } = useIntl();
  return {
    title: 'Sum Downloads',
    title_cn: '总下载',
    key: 'sum_download',
    textContent: <TopTip title="sum" />,
    tipText: (
      <>
        <EditionCountryTip type={'sum'} {...(params || {})} />
        <br />
        {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
      </>
    ),
    width: 210,
    width_cn: 150,
  };
};
export const arpuTitle = {
  title: 'ARPU',
  title_cn: '活跃ARPU',
  key: 'arpu',
  textContent: <TopTip title="arpu" />,
  width: 180,
  width_cn: 200,
};
export const rankTitle = {
  title: 'Rank',
  title_cn: '排行',
  key: 'rank',
  // textContent: <TopTip title="arpu" />,
  width: 180,
};
